import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "events-base-table",
  "data-pdf-table-section": ""
}
const _hoisted_2 = { class: "events-base-table__head" }
const _hoisted_3 = { class: "events-base-table__title" }
const _hoisted_4 = {
  key: 0,
  class: "events-base-table__legend"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableComponent = _resolveComponent("TableComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _renderSlot(_ctx.$slots, "head-actions", {}, undefined, true)
    ]),
    _renderSlot(_ctx.$slots, "filters", {}, undefined, true),
    (_ctx.legend)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.legend), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_TableComponent, {
      columns: _ctx.columns,
      storePaths: _ctx.storePaths,
      isShowNumberColumn: "",
      params: _ctx.params,
      eventConfigs: _ctx.eventConfigs,
      emptyText: _ctx.emptyText,
      updateTrigger: _ctx.updateTrigger,
      pagination: { size: 5 },
      defaultSort: _ctx.defaultSort
    }, {
      numberSuffix: _withCtx((slotProps) => [
        _renderSlot(_ctx.$slots, "numberSuffix", _normalizeProps(_guardReactiveProps(slotProps)), undefined, true)
      ]),
      _: 3
    }, 8, ["columns", "storePaths", "params", "eventConfigs", "emptyText", "updateTrigger", "defaultSort"])
  ]))
}